import { ignoreError } from '~/infra/utils';
export const heap = {
    resetIdentity () {
        ignoreError(()=>{
            var _window_heap;
            (_window_heap = window.heap) === null || _window_heap === void 0 ? void 0 : _window_heap.resetIdentity();
        });
    },
    identify (userId, _userEmail, userProperties) {
        ignoreError(()=>{
            var _window_heap, _window_heap1;
            (_window_heap = window.heap) === null || _window_heap === void 0 ? void 0 : _window_heap.identify(userId);
            (_window_heap1 = window.heap) === null || _window_heap1 === void 0 ? void 0 : _window_heap1.addUserProperties(userProperties);
        });
    },
    addEventProperties (properties) {
        ignoreError(()=>{
            var _window_heap;
            (_window_heap = window.heap) === null || _window_heap === void 0 ? void 0 : _window_heap.addEventProperties(properties);
        });
    },
    sendEventDeprecated (eventName, eventData) {
        ignoreError(()=>{
            var _window_heap;
            (_window_heap = window.heap) === null || _window_heap === void 0 ? void 0 : _window_heap.track(eventName, eventData);
        });
    },
    report (location, action, eventName, eventData) {
        ignoreError(()=>{
            var _window_heap;
            const eventNameWithProperties = getEventName(location, action, eventName);
            (_window_heap = window.heap) === null || _window_heap === void 0 ? void 0 : _window_heap.track(eventNameWithProperties, eventData);
        });
    }
};
const getEventName = (location, action, eventName)=>"".concat(location, " - ").concat(action, " - ").concat(eventName);
